import axios from 'axios';
import { Capacitor } from '@capacitor/core';

// 🔥 Correct native detection
const isNative = Capacitor.isNativePlatform();

// 🔥 Correct Android emulator host
const API_BASE_URL = process.env.REACT_APP_API_URL || (isNative
  ? 'http://10.0.2.2:3000'
  : 'http://localhost:3000');

console.log("ENV VAR REACT_APP_API_URL:", process.env.REACT_APP_API_URL);
console.log("API BASE URL:", API_BASE_URL);

const apiClient = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      try {
        window.dispatchEvent(
          new CustomEvent('api:unauthorized', {
            detail: { url: err.config?.url },
          })
        );
      } catch (e) { }
    }
    return Promise.reject(err);
  }
);

export { API_BASE_URL };
export default apiClient;
